export default __webpack_public_path__ + "static/media/hgtag-logo.fb176a7f.PNG";